import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        groupModel: '=',
        groupList: '=',
        metaFieldLists: '='
    },
    template: `
        <a class="btn main small" ng-click="vm.manageLanguages(vm.groupModel, vm.metaFieldLists, vm.groupList)">{{ 'general.Manage translations' | translate }}</a>
    `
})
export default class {
    constructor (ModalService, FormResource) {
        this.ModalService = ModalService;
        this.FormResource = FormResource;
    }

    manageLanguages (groupModel, metaFieldLists, groupList) {
        return this.ModalService.open({
            animation: true,
            template: `
                <modals-forms-meta-translation group-list="vm.groupList" group-model="vm.groupModel" meta-field-lists="vm.metaFieldLists" cancel="vm.$uibModalInstance.dismiss()"
                    update="vm.update()"
                    class="wrapper"></modals-forms-meta-translation>
                `,
            size: 'full',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.groupModel = groupModel;
                this.groupList = groupList;
                this.metaFieldLists = metaFieldLists;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/meta/translation/index.js